import classNames from 'classnames'

export default function ParkCardBadge({ park }) {
  if (!park.badge && !park.multipleBadge) return null

  let bgClass = park.isReservationApproved ? 'bg-primary' : 'bg-secondary'
  let mbClass = park.multipleBadge ? 'bg-primary' : 'd-none'

  return (
    <div className="badge-container">
      {park.badge &&
        <div className={classNames('badge', bgClass)}>
          {park.badge}
        </div>
      }

      {park.multipleBadge &&
        <div className={classNames('badge', mbClass)}>
          {park.multipleBadge}
        </div>
      }
    </div>
  )
}
